export default {
    state: {
        message: '',
        flag: false,
    },
    mutations:{
        SET_ERROR: (state, message) => {
            state.flag = true
            state.message = message
        },
        UNSET_ERROR: (state) => {
            state.flag = false
            state.message = ''
        },
    },
}